import React, { useContext } from 'react'
import { useDrop } from 'react-dnd'
import { DRAGNDROP_TYPE } from '~/enums'
import { TranslationContext } from '~/contexts/TranslationContext'
import { Context as DnDContext } from '../DnDContextProvider'
import { useLayerDropHandler } from './useLayerDropHandler'
import { DraggingItemContext } from '../DraggingItemProvider'

function useLayerDropTarget(ref, {
  layerId,
  layerIndex,
  scale,
  // getDragOffsetLeft,
  onDenied,
}) {
  const handleDrop = useLayerDropHandler()
  const { t } = useContext(TranslationContext)
  const { resetProps: resetDraggingItemProps } = useContext(DraggingItemContext)
  const {
    // setTime: setContextTime,
    setLayerHovered,
  } = React.useContext(DnDContext)

  const isIncompatibleFileGroupExtensions = item => {
    if (Object.keys(item.incompatibleFileExtensions).length > 1) {
      onDenied(`${t('MESSAGE_BOX_REMOVE_EXISTING')} ${Object.values(item.incompatibleFileExtensions)
        .reduce((res, arr) => [ ...res, ...arr ], [])
        .map(ext => ext.toUpperCase()).join(', ')}`)
      resetDraggingItemProps()
      return true
    }
    return false
  }
  const acceptedTypes = [
    DRAGNDROP_TYPE.GROUP,
    DRAGNDROP_TYPE.LAYER_ASSET,
    DRAGNDROP_TYPE.MEDIA_ITEM,
    DRAGNDROP_TYPE.TEXT_ITEM,
    DRAGNDROP_TYPE.AUDIO_ITEM,
    DRAGNDROP_TYPE.IMAGE_ITEM,
    DRAGNDROP_TYPE.PREVIEW_MEDIA_ITEM,
  ]
  const [ collectedProps, drop ] = useDrop({
    accept: acceptedTypes,
    collect: monitor => ({
      isHovered: monitor.isOver(),
      item: monitor.getItem(),
    }),
    canDrop: item => acceptedTypes.includes(item?.type),
    drop(item, monitor) {
      if (item.type === DRAGNDROP_TYPE.GROUP && isIncompatibleFileGroupExtensions(item)) {
        return
      }
      handleDrop(item, monitor, {
        onDenied, scale, layerId, layerIndex,
      })
    },
  }, [ scale ])
  // ---
  const { isHovered } = collectedProps

  React.useEffect(
    () => {
      setLayerHovered({ layerId, isHovered })
    },
    [ setLayerHovered, layerId, isHovered ]
  )

  // explicit clean up when layer is removed
  React.useEffect(
    () => () => {
      setLayerHovered({ layerId, isHovered: false })
    },
    [ setLayerHovered, layerId ]
  )
  // ---

  drop(ref)

  return collectedProps
}

export default useLayerDropTarget
